import type { Session } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase/client'

export async function getCurrentSession(): Promise<Session | null> {
  const { data, error } = await supabase.auth.getSession()
  if (error) throw error
  return data.session
}

export function onAuthSessionChange(callback: (session: Session | null) => void) {
  const { data } = supabase.auth.onAuthStateChange((_event, session) => callback(session))
  return () => data.subscription.unsubscribe()
}

export async function signOut() {
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}
